<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Prześlij film z YouTube</span>
        </v-card-title>
        <v-card-text class="mt-4">
          <v-form ref="form">
            <v-text-field
              v-model="form.url"
              label="Adres URL"
              name="url"
              prepend-icon="mdi-file"
              type="text"
              :error-messages="urlErrors"
              @input="$v.form.url.$touch()"
              @blur="$v.form.url.$touch()"
              @keydown.enter="submit"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text--secondary" text @click="close">Anuluj</v-btn>
          <v-btn color="primary" text @click="submit">Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loaderDialog" overlay-opacity="0.8" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p class="pt-4">Przesyłanie obrazu, proszę czekać...</p>
          <v-progress-linear indeterminate color="white"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { httpsUrl, youTubeUrl } from '@/plugins/vuelidate/validators';

export default {
  mixins: [validationMixin],
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      dialog: false,
      loaderDialog: false,
      errors: [],
      form: {
        url: null
      }
    };
  },
  validations: {
    form: {
      url: {
        required,
        httpsUrl,
        youTubeUrl
      }
    }
  },
  computed: {
    urlErrors() {
      const errors = [];
      if (!this.$v.form.url.$dirty) {
        return errors;
      }
      if (!this.$v.form.url.required) {
        errors.push('Adres URL jest wymagany');
      }
      if (!this.$v.form.url.httpsUrl) {
        errors.push('Niepoprawny adres URL');
      }
      if (!this.$v.form.url.youTubeUrl) {
        errors.push('Adres URL nie pochodzi z YouTube lub brakuje całości adresu');
      }
      return errors;
    },
    formValid() {
      return !this.$v.form.$invalid && !this.$v.form.$pending;
    },
    formChanged() {
      return this.$v.$anyDirty;
    }
  },
  watch: {
    show(newVal) {
      this.url = null;
      this.dialog = newVal;
    }
  },
  methods: {
    clear() {
      this.form.url = '';
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();

      if (this.formValid) {
        this.$emit('uploaded', { url: this.form.url });
        this.clear();
        this.$emit('close');
      }
    },
    close() {
      this.clear();
      this.$emit('close');
    }
  }
};
</script>
